import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from 'msp-components'
import { FormActionButtonsProps } from './FormActionButtons.types.js'

const FormActionButtons = ({
  className,
  hideCancelButton,
  saveButtonProps = {},
  cancelButtonProps = {},
  saveButtonLabel,
  cancelButtonLabel,
  onCancel = () => {}
}: FormActionButtonsProps) => {
  const { formatMessage } = useIntl()

  return (
    <div
      className={`flex flex-col space-y-4 md:flex-row-reverse md:space-x-4 md:space-y-0 md:space-x-reverse ${className}`}
    >
      <Button isSubmit className={'min-w-[128px]'} {...saveButtonProps}>
        {saveButtonLabel ||
          formatMessage({
            defaultMessage: 'Save',
            id: 'form_action_buttons.button.save'
          })}
      </Button>
      {!hideCancelButton && (
        <Button
          isSubmit
          className={'min-w-[128px]'}
          variant={'outline'}
          onClick={onCancel}
          {...cancelButtonProps}
        >
          {cancelButtonLabel ||
            formatMessage({
              defaultMessage: 'Cancel',
              id: 'form_action_buttons.button.cancel'
            })}
        </Button>
      )}
    </div>
  )
}

export default FormActionButtons
